/* eslint-disable no-undef */
//const SERVER_PORT = 'http://localhost:3001/informe';
//const SERVER_PORT = 'https://54.74.26.246:443/informe';
//import { SERVER_PORT } from '../../app/utils';

export const enviaNuevoInforme = async (data) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/informes/`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response;
};

export const traeInforme = async (num) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/informes/${num}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        }
    });
    return response;
};
